<template>
  <l-autocomplete
    v-model="localModel"
    label="Discount eligibility"
    help="
      Some schools offer discounts based on state residency or religious affiliation.
      By selecting one or more potential discounts, we can show discounted tuition where applicable.
    "
    placeholder="Search"
    :items="items"
    item-key="code"
    multiple
  >
    <input
      name="lds"
      type="hidden"
      :value="ldsDiscount ? 1 : 0"
    >

    <input
      v-for="state in stateDiscounts"
      :key="state.code"
      name="states[]"
      type="hidden"
      :value="state.code"
    >
  </l-autocomplete>
</template>

<script setup>
import LAutocomplete from "@/components/inputs/LAutocomplete.vue"
import { computed, ref, watch } from "vue"
import { find, reject } from "lodash-es"
import { useStates } from "@/composables/useStates"

const user = defineModel({ type: Object, required: true })

const emit = defineEmits(["input"])

const { states } = useStates()

const lds = {
  name: "LDS",
  code: "LDS",
  searchText: "The Church of Jesus Christ of Latter-day Saints LDS",
}

const localModel = ref(user.value.lds ? [lds, ...user.value.states] : user.value.states)

const ldsDiscount = computed(() => !!find(localModel.value ?? [], { code: "LDS" }))
const stateDiscounts = computed(() => reject(localModel.value ?? [], { code: "LDS" }))

const items = computed(() => [lds, ...states])

watch(localModel, value => {
  user.value = {
    ...user.value,
    lds: ldsDiscount.value,
    states: stateDiscounts.value,
  }

  emit("input", value)
})
</script>
